export class ChCompanySummary {
    constructor(data) {
        this.companyId = data?.companyId ?? null;
        this.totalCreated = data?.totalCreated ?? 0;
        this.totalDelivered = data?.totalDelivered ?? 0;
        this.totalFailed = data?.totalFailed ?? 0;
        this.totalIncomplete = data?.totalIncomplete ?? 0;
        this.totalDeleted = data?.totalDeleted ?? 0;
        this.deliveredByDriver = data?.deliveredByDriver ?? 0;
        this.deliveredByDispatcher = data?.deliveredByDispatcher ?? 0;
        this.ontimePercentage = data?.ontimePercentage ?? 0;
        this.avgDriveTimeMinutes = data?.avgDriveTimeMinutes ?? 0;
        this.avgDeliveryTimeMinutes = data?.avgDeliveryTimeMinutes ?? 0;
    }

    getCompanyId() { return this.companyId; }
    getTotalCreated() { return this.totalCreated; }
    getTotalDelivered() { return this.totalDelivered; }
    getTotalFailed() { return this.totalFailed; }
    getTotalIncomplete() { return this.totalIncomplete; }
    getTotalDeleted() { return this.totalDeleted; }
    getDeliveredByDriver() { return this.deliveredByDriver; }
    getDeliveredByDispatcher() { return this.deliveredByDispatcher; }
    getOntimePercentage() { return this.ontimePercentage; }
    getAvgDriveTimeMinutes() { return this.avgDriveTimeMinutes; }
    getAvgDeliveryTimeMinutes() { return this.avgDeliveryTimeMinutes; }
}

export class ChSummaryResponse {
    constructor(data) {
        this.companies = (data ?? []).map(c => new ChCompanySummary(c));
    }

    getCompanies() { return this.companies; }
}

export class ChDrilldownOrder {
    constructor(data) {
        this.orderId = data?.orderId ?? null;
        this.orderNumber = data?.orderNumber ?? "";
        this.customerName = data?.customerName ?? "";
        this.customerFormattedAddress = data?.customerFormattedAddress ?? "";
        this.placementTime = data?.placementTime ?? null;
        this.assignedTime = data?.assignedTime ?? null;
        this.deliveryTime = data?.deliveryTime ?? null;
        this.promisedDeliveryTime = data?.promisedDeliveryTime ?? null;
        this.driverName = data?.driverName ?? "";
        this.completedBy = data?.completedBy ?? "";
        this.orderStatus = data?.orderStatus ?? "";
        this.totalCost = data?.totalCost ?? 0;
        this.waitingMinutes = data?.waitingMinutes ?? 0;
        this.deliveryDeltaMinutes = data?.deliveryDeltaMinutes ?? 0;
        this.failedDeliveryTime = data?.failedDeliveryTime ?? null;
        this.deletedAt = data?.deletedAt ?? null;
        this.deletedBy = data?.deletedBy ?? "";
        this.deletedByRole = data?.deletedByRole ?? "";
    }

    getOrderId() { return this.orderId; }
    getOrderNumber() { return this.orderNumber; }
    getCustomerName() { return this.customerName; }
    getCustomerFormattedAddress() { return this.customerFormattedAddress; }
    getPlacementTime() { return this.placementTime; }
    getAssignedTime() { return this.assignedTime; }
    getDeliveryTime() { return this.deliveryTime; }
    getPromisedDeliveryTime() { return this.promisedDeliveryTime; }
    getDriverName() { return this.driverName; }
    getCompletedBy() { return this.completedBy; }
    getOrderStatus() { return this.orderStatus; }
    getTotalCost() { return this.totalCost; }
    getWaitingMinutes() { return this.waitingMinutes; }
    getDeliveryDeltaMinutes() { return this.deliveryDeltaMinutes; }
    getFailedDeliveryTime() { return this.failedDeliveryTime; }
    getDeletedAt() { return this.deletedAt; }
    getDeletedBy() { return this.deletedBy; }
    getDeletedByRole() { return this.deletedByRole; }
}

export class ChDrilldownStats {
    constructor(data) {
        this.totalCount = data?.totalCount ?? 0;
        this.deliveredByDriver = data?.deliveredByDriver ?? 0;
        this.deliveredByDispatcher = data?.deliveredByDispatcher ?? 0;
        this.ontimePercentage = data?.ontimePercentage ?? 0;
        this.totalDelivered = data?.totalDelivered ?? null;
        this.totalFailed = data?.totalFailed ?? null;
        this.totalIncomplete = data?.totalIncomplete ?? null;
        this.avgWaitingMinutes = data?.avgWaitingMinutes ?? null;
        this.criticalCount = data?.criticalCount ?? null;
        this.deletionRate = data?.deletionRate ?? null;
        this.failRate = data?.failRate ?? null;
    }

    getTotalCount() { return this.totalCount; }
    getDeliveredByDriver() { return this.deliveredByDriver; }
    getDeliveredByDispatcher() { return this.deliveredByDispatcher; }
    getOntimePercentage() { return this.ontimePercentage; }
    getTotalDelivered() { return this.totalDelivered; }
    getTotalFailed() { return this.totalFailed; }
    getTotalIncomplete() { return this.totalIncomplete; }
    getAvgWaitingMinutes() { return this.avgWaitingMinutes; }
    getCriticalCount() { return this.criticalCount; }
    getDeletionRate() { return this.deletionRate; }
    getFailRate() { return this.failRate; }
}

export class ChDrilldownResponse {
    constructor(data) {
        this.metric = data?.metric ?? "";
        this.orders = (data?.orders ?? []).map(o => new ChDrilldownOrder(o));
        this.stats = data?.stats ? new ChDrilldownStats(data.stats) : null;
        this.page = data?.page ?? 1;
        this.pageSize = data?.pageSize ?? 25;
        this.totalPages = data?.totalPages ?? 0;
        this.truncated = data?.truncated ?? false;
    }

    getMetric() { return this.metric; }
    getOrders() { return this.orders; }
    getStats() { return this.stats; }
    getPage() { return this.page; }
    getPageSize() { return this.pageSize; }
    getTotalPages() { return this.totalPages; }
}
